import {csvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/csv", csvParse);



//////////////////
// WEBPACK FOOTER
// ../~/d3-request/src/csv.js
// module id = K+Vx
// module chunks = 0